// extracted by mini-css-extract-plugin
export default {"swiper":"Furniture_swiper__jFvkn","swiperSlide":"Furniture_swiperSlide__nXh10","sliderImage":"Furniture_sliderImage__WO67J"};